<div class="c-adventureQuestInfo">
  <slotcom-navigation-button
    type="close"
    (click)="closeModal()">
  </slotcom-navigation-button>

  <div class="c-adventureQuestInfo__container">
    <span class="text title">{{ 'home.live-ops.adventure-quest.modal-info.title' | translate }}</span>

    <div class="c-adventureQuestInfo__explanation">
      <div class="explanation">
        <div
          class="image image-1"
          theming
          themingGroup="adventurequest"
          themingAsset="step-one"
          [themingOverride]="adventureQuestInfoModalData?.data?.assets"></div>
        <span class="text subtitle">{{ 'home.live-ops.adventure-quest.modal-info.step-1' | translate }}</span>
      </div>

      <div
        class="arrow arrow-1"
        theming
        themingGroup="adventurequest"
        themingAsset="arrow"
        [themingOverride]="adventureQuestInfoModalData?.data?.assets"></div>

      <div class="explanation">
        <div
          class="image image-2"
          theming
          themingGroup="adventurequest"
          themingAsset="step-two"
          [themingOverride]="adventureQuestInfoModalData?.data?.assets"></div>
        <span class="text subtitle">{{ 'home.live-ops.adventure-quest.modal-info.step-2' | translate }}</span>
      </div>

      <div
        class="arrow arrow-2"
        theming
        themingGroup="adventurequest"
        themingAsset="arrow"
        [themingOverride]="adventureQuestInfoModalData?.data?.assets"></div>

      <div class="explanation">
        <div
          class="image image-3"
          theming
          themingGroup="adventurequest"
          themingAsset="step-three"
          [themingOverride]="adventureQuestInfoModalData?.data?.assets"></div>
        <span class="text subtitle">{{ 'home.live-ops.adventure-quest.modal-info.step-3' | translate }}</span>
      </div>
    </div>
  </div>
</div>
